export default __webpack_public_path__ + "static/media/active-my-patient.8a6dbbfb.svg";